const createObjectConversion = (financing, proposal) => ({
  financing,
  proposal,
})

const returnConversionObject = dataLayer => {
  const conversionObject = dataLayer.conversion || {}
  const financing = conversionObject.financing || {}
  const proposal = conversionObject.proposal || {}
  return {
    financing,
    proposal,
  }
}

const addProposalId = (proposal, proposalID) => ({
  ...proposal,
  proposalID,
})

const addOffersValue = (proposal, carDelivery, offers) => ({
  ...proposal,
  optin: {
    carDelivery,
    offers,
  },
})

export {
  createObjectConversion,
  returnConversionObject,
  addProposalId,
  addOffersValue,
}
